import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteField = ({ 
  onDeleteField, 
  selectedNodeData, 
  fieldIndex, 
  fieldData 
}: { 
  onDeleteField: () => void; 
  selectedNodeData: any;
  fieldIndex: number;
  fieldData: any;
}) => {
  return (
    <IconButton
      color="error"
      onClick={() => {
        console.log('🗑️ Deleting field:', {
          fieldIndex,
          fieldUid: fieldData?.uid,
          fieldQuestion: fieldData?.question,
          fieldType: fieldData?.inputComponent,
          totalFieldsBeforeDelete: selectedNodeData?.fields?.length
        });
        onDeleteField();
      }}
      size="large"
       sx={{ 
        mb: 1, 
        
        '&:hover': {
          backgroundColor: 'transparent', // Removes default hover background
          opacity: 1, // Ensures no opacity change on hover
        }
      }}
    >
      <DeleteIcon />
    </IconButton>
  );
};

export default DeleteField;